import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import './AgeConfirmation.css';

const AgeConfirmation = ({ onConfirm }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const ageConfirmed = getCookie('ageConfirmed');
    if (!ageConfirmed) {
      setIsVisible(true);
    }
  }, []);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  };

  const handleConfirm = () => {
    setCookie('ageConfirmed', 'true', 30); // Cookie expires in 30 days
    setIsVisible(false);
    if (onConfirm) {
      onConfirm(true);
    }
  };

  const handleDecline = () => {
    // Redirect to a safe external site
    window.location.href = 'https://www.google.com';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Modal isOpen={isVisible} backdrop="static" keyboard={false} className="age-confirmation-modal" centered>
      <ModalHeader className="age-confirmation-header">
        Age Verification Required
      </ModalHeader>
      <ModalBody className="age-confirmation-body text-center">
        <div className="age-confirmation-content">
          <h4>Are you 21 or older?</h4>
          <p className="text-muted small">
            By clicking "Yes", you certify that you are at least 21 years of age.
          </p>
        </div>
      </ModalBody>
      <ModalFooter className="age-confirmation-footer justify-content-center">
        <Button color="success" size="lg" onClick={handleConfirm} className="mx-2">
          Yes, I am 21+
        </Button>
        <Button color="secondary" size="lg" onClick={handleDecline} className="mx-2">
          No, I am under 21
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AgeConfirmation;